export default [
  {
    path: '/favoucherqlts/:key?',
    name: 'fixedasset',
    component: () => import('@/views/faVoucherQLTS/FAVoucherIndex.vue'),
    meta: {},
  },
];
